import React from 'react'
import cx from 'classnames'
import { useMemo } from 'sb-hooks'
import { FormattedMessage } from 'sb-react-intl'
import { getTruncatedText } from 'common/helpers'

import toggleOpen  from 'decorators/toggleOpen'

import messages from './messages'
import s from './ToggleTruncate.scss'


type ToggleTruncateProps = {
  children: any
  className?: string
  length?: number
  flexibilityFactor?: number
  isToggleActive?: boolean
  toggleOpen?: () => void
  toggleClose?: () => void
}

const ToggleTruncate: React.FunctionComponent<ToggleTruncateProps> = (props) => {
  const {
    className,
    children = '', length = 0, flexibilityFactor = 1.3,
    isToggleActive, toggleOpen, toggleClose,
  } = props

  // 1.3 here means additional 30% to length
  // so if children text length is 258 and length prop is 200 we don't truncate text
  const isTruncateNecessary = length > 1 && children.length > length * flexibilityFactor

  const truncatedText = useMemo(
    () => isTruncateNecessary ? getTruncatedText(children, length) : children,
    [ isTruncateNecessary, children, length ]
  )

  if (!isTruncateNecessary) {
    return <div className={className} dangerouslySetInnerHTML={{ __html: children }} />
  }

  const rootClassName = cx(className, isToggleActive ? 'toggle-open' : 'toggle-close')
  const text          = isToggleActive ? children : truncatedText
  const actionTitle   = isToggleActive ? messages.hide : messages.readMore
  const onClick       = isToggleActive ? toggleClose : toggleOpen

  return (
    <div className={rootClassName}>
      <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
      <FormattedMessage
        className={s.action}
        tag="button"
        onClick={onClick}
        {...actionTitle}
      />
    </div>
  )
}


export default toggleOpen()(ToggleTruncate)
